import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export interface KpiCardItem {
  title: string;
  value: string;
  subtext: string;
}

interface GenericKpiCardsProps {
  items: KpiCardItem[];
}

export const GenericKpiCards = ({ items }: GenericKpiCardsProps) => {
  const lgGridCols =
    items.length <= 3 ? 'lg:grid-cols-3' : items.length === 4 ? 'lg:grid-cols-4' : 'lg:grid-cols-5';

  return (
    <div className={`grid gap-4 md:grid-cols-3 ${lgGridCols}`}>
      {items.map((item) => (
        <Card key={item.title} className="border-dashed">
          <CardHeader className="pb-2">
            <CardDescription>{item.title}</CardDescription>
            <CardTitle className="text-3xl">{item.value}</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground text-sm">{item.subtext}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
